import React from 'react'
import ModelZoo from '../components/ModelZoo/ModelZoo'

const ModelZooPage = () => {
  return (
    <div>
      <ModelZoo/>
    </div>
  )
}

export default ModelZooPage